module.exports = __webpack_public_path__ + "static/media/12.69d99b53.svg";